import React from 'react'
import { Link, useLocation } from 'react-router-dom';
import ArrowLeft from '../../Assets/Arrow left.svg';
import ReturnRatioReasonBar from './Components/ReturnRatioReasonBar';

function ReturnRatio() {
    const location = useLocation();

    return (
        <div className="w-full overflow-y-scroll pb-16">
            <div className="flex items-center justify-between gap-6 relative m-[20px_19px_24px_20px]">
                <div className="w-fit flex items-center">
                    <Link to={`${location.pathname.split('/').slice(0, -1).join('/')}`} className="img p-[10px] flex items-center justify-center">
                        <img className='w-6 h-6 text-[#666666]' src={ArrowLeft} alt="" />
                    </Link>

                    <h1 className="p-[6px] text-[#121212] font-urbanist-regular font-bold leading-8 text-[24px]">Return Ratio</h1>
                </div>

                <div className="flex gap-4">
                    <button onClick={() => { alert('Downloading Report...') }} className='bg-maiprimaryColor hover:bg-primaryAccent rounded-md px-3 py-[10px] text-buttonText font-semibold text-[14px] leading-[22px] font-urbanist-regular'>
                        Download Report
                    </button>
                </div>
            </div>

            <div className="mx-5">
                <h1 className='font-urbanist-regular font-medium text-[20px] leading-6 text-[#121212]'>Reason for return on 7 March 2024</h1>
            
                <div className="bg-[#BCFCD7] rounded-[7px] px-4 py-[10px] mt-4">
                    <p className='font-urbanist-regular font-medium text-[14px] leading-6 text-[#000000]'>The return ratio stands at 9%, reflecting a decrease of 16% from the previous month.</p>
                </div>

                <div className="mt-3 border border-[#EAEAEA] rounded-lg">
                    <div className="flex bg-[#F5F5F5] font-urbanist-regular font-semibold">
                        <h2 className="w-[32%] max-[1280px]:w-[29%] max-[1024px]:w-[28%] px-[10px] py-2 text-[16px] max-[1152px]:text-[14px] leading-8 max-[1152px]:leading-6 text-[#121212]">Reasons</h2>
                        <h2 className="w-[17%] max-[1024px]:w-[15.5%] px-[10px] py-2 text-[16px] max-[1152px]:text-[14px] leading-8 max-[1152px]:leading-6 text-[#121212]">%age</h2>
                        <h2 className="w-[17%] max-[1280px]:w-[20%] max-[1024px]:w-[21.5%] px-[10px] py-2 text-[16px] max-[1152px]:text-[14px] leading-8 max-[1152px]:leading-6 text-[#121212]">Total Orders Returned</h2>
                        <h2 className="w-[17%] max-[1024px]:w-[16.5%] px-[10px] py-2 text-[16px] max-[1152px]:text-[14px] leading-8 max-[1152px]:leading-6 text-[#121212]">Total Reviews</h2>
                        <h2 className="w-[17%] max-[1024px]:w-[18.5%] px-[10px] py-2 text-[16px] max-[1152px]:text-[14px] leading-8 max-[1152px]:leading-6 text-[#121212]">Avg. Review Rating</h2>
                    </div>

                    <ReturnRatioReasonBar />
                    <ReturnRatioReasonBar />
                    <ReturnRatioReasonBar />
                    <ReturnRatioReasonBar />
                    <ReturnRatioReasonBar />
                </div>
            </div>
        </div>
    )
}

export default ReturnRatio;
